import { render, staticRenderFns } from "./programa.vue?vue&type=template&id=b09ee864"
import script from "./programa.vue?vue&type=script&lang=js"
export * from "./programa.vue?vue&type=script&lang=js"
import style0 from "./programa.vue?vue&type=style&index=0&id=b09ee864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports